/**
 * 菜单/页签显示配置相关API
 */
import request from '@/utils/request'

// 获取页签显示配置
export function getMenuConfig() {
  return request({
    url: 'system/menu/config',
    method: 'get'
  })
}

// 更新页签显示配置（后台管理用）
export function updateMenuConfig(data) {
  return request({
    url: 'system/menu/config',
    method: 'put',
    data
  })
}
